import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import OligoCredentialsForm from "./OligoCredentialsForm";
import OligoMappingForm from "./OligoMappingForm";

export default function OligoConfigListing(props) {

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={OligoMappingForm}
      CredentialsForm={OligoCredentialsForm}
      componentName="Image Name"
      componentKey="imageName"
    />
  );
}